<script lang="ts">
</script>

<div class="p-4 text-center">
    <div class="subtitle">Relatórios</div>
    <div>Escolha um relatório para ser exibido aqui.</div>
</div>
